import FileObject from '../standardBooks/FileObject'
import Consts from '../../consts/adminConsts'

export default class {

    Id = null;

    SubType = null;

    Name = null;

    Code = null;

    ImageUrl = null;

    Image = new FileObject();

    Prompt = null;
    
    MmlRangeForTea = [];

    MmlRangeForCoffee = [];

    mapFromDto(mmlCategoryDto) {
        if(!mmlCategoryDto)
            return this;

        this.Id = mmlCategoryDto.Id;
        this.Name = mmlCategoryDto.Name;
        this.SubType = Consts.TradePointTypes.find(e => e.Text == mmlCategoryDto.SubType);
        this.ImageUrl = mmlCategoryDto.ImageUrl;
        this.Prompt = mmlCategoryDto.Prompt;
        this.Code = Consts.SegmentCodes.find(e => e.Id == mmlCategoryDto.Code);
        this.MmlRangeForTea = mmlCategoryDto.MmlRangeForTea.map((elem, index) => { return { Id: index, Text: elem } });
        this.MmlRangeForCoffee = mmlCategoryDto.MmlRangeForCoffee.map((elem, index) => { return { Id: index, Text: elem } }); 

        return this;
    }

    mapToDto() {
        let result = JSON.parse(JSON.stringify(this));

        result.SubType = result.SubType.Text;
        result.Code = result.Code.Id;

        if(!this.Image.IsUpload()) result.Image = null;

        result.MmlRangeForTea = result.MmlRangeForTea.map(e => e.Text);
        result.MmlRangeForCoffee = result.MmlRangeForCoffee.map(e => e.Text);

        return result;
    }

    isValid() {
        let isImage = this.ImageUrl != null || this.Image.IsUpload();

        return Boolean(this.Name) &&
               Boolean(this.SubType) &&
               Boolean(this.Code) &&
               isImage;
    }

}